// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.service__details-section {
  padding: 4rem 0;
}
.service__details-section .custom-container .content-section {
  background: #E0E7FF;
  padding: 4rem 2rem;
  min-height: 55vh;
  font-family: "Roboto", "SolaimanLipi", sans-serif;
}
.service__details-section .custom-container .content-section .page-title {
  font-size: 2.2rem;
  text-align: center;
  color: #08245A;
}
.service__details-section .custom-container .content-section .page-title::after {
  content: "";
  display: block;
  height: 8px;
  width: 60px;
  background: #08245A;
  margin: 0.7rem auto 0;
  border-radius: 20px;
}
.service__details-section .custom-container .content-section .content-body {
  margin: 3rem auto 0;
}
.service__details-section .custom-container .content-section .content-body .card-container {
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 3px 0px;
  border-radius: 8px;
}
@media (min-width: 768px) {
  .service__details-section .custom-container .content-section .content-body .card-container {
    flex-direction: row;
  }
}
.service__details-section .custom-container .content-section .content-body .card-container .card-title-section {
  padding: 1rem 1rem 1rem 1.5rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 8px 0px 0px 8px;
  flex: 1 1;
  align-self: flex-start;
  height: 100%;
}
.service__details-section .custom-container .content-section .content-body .card-container .card-title-section span {
  font-size: 125%;
  color: #313d4f;
  font-weight: 500;
}
.service__details-section .custom-container .content-section .content-body .card-container .card-content-section {
  padding: 1.6rem;
  border-radius: 0px 8px 8px 0px;
  flex: 4 1;
  word-break: break-all;
}
.service__details-section .custom-container .content-section .content-body .card-container .card-content-section table {
  height: auto !important;
}
.service__details-section .custom-container .content-section .content-body .card-container .card-content-section .short-text {
  max-height: 66px;
  overflow: hidden;
}
.service__details-section .custom-container .content-section .content-body .card-container .card-content-section .see-more-less-btn {
  padding: 0;
  outline: none;
  border: none;
  color: purple;
  font-weight: 600;
  background: transparent;
}
.service__details-section .custom-container .content-section .content-body .necessary-document-card {
  background: #d3dde9;
}
.service__details-section .custom-container .content-section .content-body .necessary-document-card .card-content-section {
  background: #f1f3f6;
}
.service__details-section .custom-container .content-section .content-body .work-procedure-card {
  background: #dae0f7;
}
.service__details-section .custom-container .content-section .content-body .work-procedure-card .card-content-section {
  background: #edf1ff;
}
.service__details-section .custom-container .content-section .content-body .time-of-settlement-card {
  background: #dae9f7;
}
.service__details-section .custom-container .content-section .content-body .time-of-settlement-card .card-title-section {
  align-self: center;
}
.service__details-section .custom-container .content-section .content-body .time-of-settlement-card .card-content-section {
  background: #edf8ff;
  display: flex;
  align-items: center;
}
.service__details-section .custom-container .content-section .content-body .application-card {
  background: #daf7f1;
}
.service__details-section .custom-container .content-section .content-body .application-card .card-title-section {
  align-self: center;
}
.service__details-section .custom-container .content-section .content-body .application-card .card-content-section {
  background: #edffff;
  display: flex;
  align-items: center;
}
.service__details-section .custom-container .content-section .content-body .comment-card {
  background: #d1edf5;
}
.service__details-section .custom-container .content-section .content-body .comment-card .card-title-section {
  align-self: center;
}
.service__details-section .custom-container .content-section .content-body .comment-card .card-content-section {
  background: #e5f3f7;
}
.service__details-section .custom-container .content-section .content-body .comment-card .card-content-section .send-btn {
  border: none;
  background: #009648;
  color: #fff;
  border-radius: 6px;
  padding: 0.5rem 1.5rem;
}
.service__details-section .custom-container .content-section .content-body .comment-card .card-content-section .send-btn:hover, .service__details-section .custom-container .content-section .content-body .comment-card .card-content-section .send-btn:active {
  background: #005328;
}
.service__details-section .custom-container .content-section .content-body .comment-card .card-content-section .send-btn:focus {
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/pages/services/details.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;AADF;AAII;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;AAFN;AAIM;EACE,iBAAA;EACA,kBAAA;EACA,cAAA;AAFR;AAIQ;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AAFV;AAMM;EACE,mBAAA;AAJR;AAMQ;EACE,qBAAA;EACA,aAAA;EACA,sBAAA;EAMA,+CAAA;EACA,kBAAA;AATV;AAIU;EALF;IAMI,mBAAA;EADV;AACF;AAMU;EACE,8BAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,sBAAA;EACA,YAAA;AAJZ;AAMY;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAJd;AAQU;EACE,eAAA;EACA,8BAAA;EACA,SAAA;EACA,qBAAA;AANZ;AAQY;EACE,uBAAA;AANd;AASY;EACE,gBAAA;EACA,gBAAA;AAPd;AAUY;EACE,UAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;AARd;AAaQ;EACE,mBAAA;AAXV;AAaU;EACE,mBAAA;AAXZ;AAeQ;EACE,mBAAA;AAbV;AAeU;EACE,mBAAA;AAbZ;AAiBQ;EACE,mBAAA;AAfV;AAiBU;EACE,kBAAA;AAfZ;AAkBU;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;AAhBZ;AAoBQ;EACE,mBAAA;AAlBV;AAoBU;EACE,kBAAA;AAlBZ;AAqBU;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;AAnBZ;AAuBQ;EACE,mBAAA;AArBV;AAuBU;EACE,kBAAA;AArBZ;AAwBU;EACE,mBAAA;AAtBZ;AAwBY;EACE,YAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AAtBd;AAwBc;EAEE,mBAAA;AAvBhB;AA0Bc;EACE,aAAA;AAxBhB","sourcesContent":["@import \"./src/assets/css/common/variables\";\r\n\r\n.service__details-section {\r\n  padding: 4rem 0;\r\n\r\n  .custom-container {\r\n    .content-section {\r\n      background: #E0E7FF;\r\n      padding: 4rem 2rem;\r\n      min-height: 55vh;\r\n      font-family: \"Roboto\", \"SolaimanLipi\", sans-serif;\r\n\r\n      .page-title {\r\n        font-size: $page-title;\r\n        text-align: center;\r\n        color: #08245A;\r\n\r\n        &::after {\r\n          content: \"\";\r\n          display: block;\r\n          height: 8px;\r\n          width: 60px;\r\n          background: #08245A;\r\n          margin: .7rem auto 0;\r\n          border-radius: 20px;\r\n        }\r\n      }\r\n\r\n      .content-body {\r\n        margin: 3rem auto 0;\r\n\r\n        .card-container {\r\n          margin-bottom: 1.5rem;\r\n          display: flex;\r\n          flex-direction: column;\r\n\r\n          @media (min-width: 768px) {\r\n            flex-direction: row;\r\n          }\r\n\r\n          box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 3px 0px;\r\n          border-radius: 8px;\r\n\r\n          .card-title-section {\r\n            padding: 1rem 1rem 1rem 1.5rem;\r\n            display: flex;\r\n            justify-content: flex-start;\r\n            align-items: center;\r\n            border-radius: 8px 0px 0px 8px;\r\n            flex: 1;\r\n            align-self: flex-start;\r\n            height: 100%;\r\n\r\n            span {\r\n              font-size: 125%;\r\n              color: #313d4f;\r\n              font-weight: 500;\r\n            }\r\n          }\r\n\r\n          .card-content-section {\r\n            padding: 1.6rem;\r\n            border-radius: 0px 8px 8px 0px;\r\n            flex: 4;\r\n            word-break: break-all;\r\n\r\n            table {\r\n              height: auto !important;\r\n            }\r\n\r\n            .short-text{\r\n              max-height: 66px;\r\n              overflow: hidden;\r\n            }\r\n\r\n            .see-more-less-btn {\r\n              padding: 0;\r\n              outline: none;\r\n              border: none;\r\n              color: purple;\r\n              font-weight: 600;\r\n              background: transparent;\r\n            }\r\n          }\r\n        }\r\n\r\n        .necessary-document-card {\r\n          background: #d3dde9;\r\n\r\n          .card-content-section {\r\n            background: #f1f3f6;\r\n          }\r\n        }\r\n\r\n        .work-procedure-card {\r\n          background: #dae0f7;\r\n\r\n          .card-content-section {\r\n            background: #edf1ff;\r\n          }\r\n        }\r\n\r\n        .time-of-settlement-card {\r\n          background: #dae9f7;\r\n\r\n          .card-title-section {\r\n            align-self: center;\r\n          }\r\n\r\n          .card-content-section {\r\n            background: #edf8ff;\r\n            display: flex;\r\n            align-items: center;\r\n          }\r\n        }\r\n\r\n        .application-card {\r\n          background: #daf7f1;\r\n\r\n          .card-title-section {\r\n            align-self: center;\r\n          }\r\n\r\n          .card-content-section {\r\n            background: #edffff;\r\n            display: flex;\r\n            align-items: center;\r\n          }\r\n        }\r\n\r\n        .comment-card {\r\n          background: #d1edf5;\r\n\r\n          .card-title-section {\r\n            align-self: center;\r\n          }\r\n\r\n          .card-content-section {\r\n            background: #e5f3f7;\r\n\r\n            .send-btn {\r\n              border: none;\r\n              background: #009648;\r\n              color: #fff;\r\n              border-radius: 6px;\r\n              padding: 0.5rem 1.5rem;\r\n\r\n              &:hover,\r\n              &:active {\r\n                background: #005328;\r\n              }\r\n\r\n              &:focus {\r\n                outline: none;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
